import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
	open: boolean;
	setOpen: (open: boolean) => void;
	text: string;
	type?: string;
	className?: string;
	id?: string;
}

const AlertModal = ({ open, setOpen, text, type = 'alert', id, className = '' }: Props) => {
	const { t } = useTranslation();
	const handleClose = () => {
		setOpen(!open);
	};

	return (
		<>
			<Dialog
				open={open}
				keepMounted
				onClose={handleClose}
				aria-describedby="alert-dialog-slide-description"
				PaperProps={{
					sx: {
						zIndex: 2000, // or any number higher than your other components
					},
					className: `${className}`,
				}}
				id={id}
			>
				<Box>
					<DialogTitle>{t('warning')}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">{t(text)}</DialogContentText>
					</DialogContent>
					<DialogActions>
						{type === 'confirm' && <Button onClick={handleClose}>{t('cancel')}</Button>}
						<Button onClick={handleClose}>{t('confirm')}</Button>
					</DialogActions>
				</Box>
			</Dialog>
		</>
	);
};

export default AlertModal;
